import { render } from "./IconTrekFrameStyle.vue?vue&type=template&id=0ab3f3ac"
import script from "./IconTrekFrameStyle.vue?vue&type=script&lang=js"
export * from "./IconTrekFrameStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__